import parsePhoneNumberFromString from "libphonenumber-js";

export const getServicesArray = (services) => {    
    if (typeof services === 'string') {
        try {
            const parsedArray = JSON.parse(services);
            if (Array.isArray(parsedArray)) {
                return parsedArray;
            }else{
                return JSON.parse(parsedArray);
            }
        } catch (e) {
            console.error('Invalid JSON string:', e);
        }
    }
    return Array.isArray(services) ? services : [];
}

export const isValidPhoneNumber = (inputNumber, country) => {
    try {
        const phoneNumber = parsePhoneNumberFromString(inputNumber, country?.iso2?.toUpperCase());
        return phoneNumber?.isValid() || false;
    } catch (err) {
        console.log(err)
    }
};

export const validateDescription = (value) => {
    const maxLength = 255;
    const regex = /^[a-zA-Z0-9 ,.?/()@$'\n]*$/;

    if (value.length > maxLength) {
        return {
            valid: false,
            error: `Description cannot exceed ${maxLength} characters.`
        };
    } else if (!regex.test(value)) {
        return {
            valid: false,
            error: 'Description contains invalid characters.'
        };
    } else {
        return {
            valid: true,
            error: ''
        };
    }

}

export const pluralize = (word) => {
    if (!!word) {
        if (word.endsWith('y') && !word.endsWith('ay') && !word.endsWith('ey') && !word.endsWith('oy') && !word.endsWith('uy')) {
            return word.slice(0, -1) + 'ies';
        } else if (word.endsWith('s') || word.endsWith('x') || word.endsWith('z') || word.endsWith('ch') || word.endsWith('sh')) {
            return word + 'es';
        } else {
            return word + 's';
        }
    }
}

export const trimFromString = (str)=>{
    if(!!str){
        let newStrAry = str.trim().split(' ');
        let joinStrAry = newStrAry.join(' ');        
        return joinStrAry;
    }
}


export const filterBySlug = (businessCatData, slug) => {        
    if(!!businessCatData && businessCatData.length>0){
        let bbData = businessCatData.filter(category => category.cat_slug == slug);
        return bbData?bbData[0]?.cat_name:slug;
    }else{
        return slug;
    }
};

export const getcoutryfromlocation = () => {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          try {
            const { latitude, longitude } = position.coords;
  
            const response = await fetch(
              `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${latitude}&longitude=${longitude}&localityLanguage=en`
            );
            const data = await response.json();
  
            if (data?.countryCode) {
              resolve(data.countryCode);
            } else {
              resolve(null);
            }
          } catch (error) {
            console.error("Error fetching location data:", error);
            reject(error);
          }
        },
        (error) => {
          console.error("Geolocation error:", error);
          reject(error);
        }
      );
    });
};